// extracted by mini-css-extract-plugin
export default {"ToolBox":"ToolBox_ToolBox__FWw4Y","border":"ToolBox_border__PrhrV","Upload":"ToolBox_Upload__v5gIN"};